import React from "react";
import { changeTitle } from "../data/GeneralFunction";

export default function WineBars() {
  changeTitle(`Findwine | Wine-Bars`);

  return <div>WineBars</div>;
}
